import { render, staticRenderFns } from "./BirthDate.vue?vue&type=template&id=bd034764&scoped=true&"
import script from "./BirthDate.vue?vue&type=script&lang=js&"
export * from "./BirthDate.vue?vue&type=script&lang=js&"
import style0 from "./BirthDate.vue?vue&type=style&index=0&id=bd034764&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd034764",
  null
  
)

export default component.exports